module.exports = __webpack_public_path__ + "static/media/conclusion.3b6cb2ac.jpg";